const langEN = {
  dv1: "Demo media 1",
  dv2: "Demo media 2",
  sjkViews: "19K views",
  ltqian: "2 days ago",
  ssekViews: "32K views",
  ytqian: "1 day ago",
  editPattern: "Edit pattern for this media",
  createPattern: "Create a pattern for this media",
  SyncToy: "Sync Lovense toy to media",
  connectRemote: "Connect to Remote",
  "Connect to Remote": "Connect to Remote",
  "Connected to Remote": "Connected to Remote",
  connecting: "Connecting...",
  "Connecting...": "Connecting...",
  connectFail: "Connection failed",
  "Connection failed": "Connection failed",
  patternEditor: "Pattern Editor",
  "Pattern Editor": "Pattern Editor",
  "Edit Pattern": "Edit Pattern",
  editMode: "Edit Mode",
  "Edit Mode": "Edit Mode",
  back: "Back",
  submit: "Submit",
  Submit: "Submit",
  exit: "Exit",
  Exit: "Exit",
  submitSure: "Do you want to submit your pattern?",
  submitExit: "Submit and Exit",
  cancel: "Cancel",
  Cancel: "Cancel",
  yes: "Yes",
  Yes: "Yes",
  preview: "Preview",
  Preview: "Preview",
  vibration: "Vibration",
  previewTip1: "Connect toy(s) to Lovense Remote and preview your pattern on the toy(s)",
  previewTip2: "1. Download the Lovense Remote app (iOS/Android)",
  previewTip3: "(Available on App Store and Google Play)",
  previewTip4: "2. Connect your Lovense toy to Lovense Remote",
  previewTip5: "(turn on the toy, open the app, tap the chain icon in the top right corner)",
  previewTip6: "3. Scan the QR Code in Lovense Remote",
  previewTip7: "(tap \"+\" in the top right corner, choose \"Scan QR\")",
  syncing: "Syncing Lovense toy to media",
  unsync: "Unsync",
  retry: "Retry",
  end: "End",
  reconnecting: "Reconnecting...",
  unsupport: "Lovense toy unsupported",
  disconnect: "Toy disconnected",
  syncAgain: "Sync again",
  disconnectApp: "Disconnected from Remote app",
  clickPreview: "Click \"Connect to Remote\" to connect your toy(s) and preview your pattern with the Lovense Remote app.",
  lsUnsupport: "Lovense toy unspported",
  "one toy synced": "one toy synced",
  "two toys synced": "two toys synced",
  "The toys are synced to media": "The toys are synced to media",
  OK: "OK",
  "Please create a pattern first!": "Please create a pattern first!",
  "Pattern data can not be empty!": "Pattern data can not be empty!",
  "Pattern submitted successfully!": "Pattern submitted successfully!",
  "Failed to submit pattern, please try again!": "Failed to submit pattern, please try again!",
  "Submit and Exit": "Submit and Exit",
  "Do you want to submit your pattern?": "Do you want to submit your pattern?",
  notHaveToy: "Do not own a Lovense toy?",
  clickHere: "Click here",
  findOne: "to find the perfect one for you",
  "QR Code": "QR Code",
  "and": "and",
};
export default langEN;